module.exports = __webpack_public_path__ + "static/media/zenodo-login.62ffd98f.png";